import { useQuery } from "@tanstack/react-query"

import { ContentService } from "@/client"
import type { TopicQuestionsPublic } from "@/client/types.gen"

interface TopicQuestionsParams {
  topicId: string
  search?: string
  page: number
  pageSize: number
}

export const topicQueryKeys = {
  list: (params: Record<string, unknown>) => ["admin-topics", params] as const,
  detail: (topicId: string) => ["topic-detail", topicId] as const,
  questions: (
    topicId: string,
    params: { page: number; search?: string; pageSize: number },
  ) => ["topic-questions", topicId, params] as const,
  untagged: (params: { page: number; search?: string }) =>
    ["untagged-questions", params] as const,
}

export function useTopicQuestions({
  topicId,
  search,
  page,
  pageSize,
}: TopicQuestionsParams) {
  return useQuery<TopicQuestionsPublic>({
    queryKey: topicQueryKeys.questions(topicId, { page, search, pageSize }),
    queryFn: () =>
      ContentService.listQuestionsForTopic({
        topicId,
        q: search,
        page,
        pageSize,
      }),
    enabled: Boolean(topicId),
    placeholderData: (previousData) => previousData,
  })
}
